
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMobileDesc = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 44 44",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(11 5)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  stroke: "#000",
  strokeWidth: 2.75,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  transform: "rotate(-90 11 17)",
  x: -6,
  y: 6,
  width: 34,
  height: 22,
  rx: 2.75
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 26a2.2 2.2 0 1 0 0 4.4 2.2 2.2 0 0 0 0-4.4z",
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "nonzero"
}))));

      const __svgRaw = "<svg width=\"44\" height=\"44\" viewBox=\"0 0 44 44\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <g transform=\"translate(11 5)\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <rect stroke=\"#000\" stroke-width=\"2.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\" transform=\"rotate(-90 11 17)\" x=\"-6\" y=\"6\" width=\"34\" height=\"22\" rx=\"2.75\"/>\r\n        <path d=\"M11 26a2.2 2.2 0 1 0 0 4.4 2.2 2.2 0 0 0 0-4.4z\" fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"nonzero\"/>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/mobile-desc.53db6d21e995f51977d6276cc25aa7fe.svg"),
        {
          React: SvgMobileDesc,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      